export const ru = {
  lang: "ru",
  rules: "Правила",
  cupra: "Cupra Formentor",
  rulesheading: "Правила дополнительного розыгрыша Vikinglotto 2025",
  language: "Language",
  heroTitle1: "VIKINGLOTTO",
  heroTitle2: "LISALOOS",
  buyticket: "Купить билет",
  heroSubtitle:
    "Разыгрываем два подключаемых гибрида Cupra Formentor, а также 5 × 10 000 € и 10 × 5000 €!",
  watchVideo: "...",
  footerDisclaimer:
    "Внимание! Вы имеете дело с рекламой азартной игры. Азартные игры не являются средством решения материальных проблем. Ознакомьтесь с правилами и поступайте ответственно!",
  rulesContent: "...",
  home: "Home",
  skipToContent: "Skip to main content",
  navMenu: "Main Navigation",
  videoDescription: "...",
};
